'use client'

import type { Messages } from '@lingui/core'
import {
	createContext,
	type PropsWithChildren,
	useContext,
	useMemo,
} from 'react'
import { I18nProvider } from '@lingui/react'

import i18n from '~/i18n'
import type { Locale } from '~/i18n/routing'

type LocaleContextValue = {
	locale: Locale
}

const LocaleContext = createContext<LocaleContextValue>({
	locale: 'fr',
})

export const useLocaleContext = () => useContext(LocaleContext)

export const LocaleProvider = ({
	children,
	locale,
	messages,
}: PropsWithChildren<{
	locale: Locale
	messages: Messages
}>) => {
	const value = useMemo(() => ({ locale }), [locale])

	if (i18n.locale !== locale) {
		i18n.loadAndActivate({ locale, messages })
	}

	return (
		<LocaleContext.Provider value={value}>
			<I18nProvider i18n={i18n}>{children}</I18nProvider>
		</LocaleContext.Provider>
	)
}
